<template>
  <a class="logo" href="/">
    <img :src="logo" alt="logo" />
  </a>
</template>

<script>
export default {
  name: "logo",
  components: {},
  props: {},
  data() {
    return {
      logo: require("@/assets/logo-h.png")
    };
  },
  methods: {},
  computed: {},
  created() {},
  mounted() {},
  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
  padding: 10px 0;
  width: 100%;
  font-size: 0;
  display: block;
}
.logo img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/logo/index.vue